import type { SceneElement } from '@editorStores'
import PlanAreaFrameLines, { PlanAreaFrameLinesProps } from './PlanAreaFrameLines'

/**
 * Control store selector: the unsaved plan settings a plan settings form is previewing in the
 * scene (its `PlanAreaFrameLines` scene element, see `usePlanSettingsScenePreview`), if any.
 * Scene visuals of the saved settings use these instead meanwhile, so they match the preview.
 */
export const selectPreviewedPlanSettings = (state: {
  sceneElements: SceneElement<object>[]
}): PdfPlanSettings | undefined => {
  const preview = state.sceneElements.find(element => element.component === PlanAreaFrameLines)
  return (preview?.properties as PlanAreaFrameLinesProps | undefined)?.planSettings
}
